export default function PHP_substr() {
  return (
    <div>
      <h1>PHP_substr</h1>
    </div>
  );
}
